<!-- src/components/common/LangueSelect.vue -->
<!-- Choix de la langue de l'espace client (mémorisé sur ce navigateur). Absent de l'admin, qui
     reste en français. -->
<template>
  <label class="inline-flex items-center gap-1 text-sm text-gray-600">
    <span class="sr-only">{{ $t('commun.langue') }}</span>
    <svg class="h-4 w-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
    </svg>
    <select :value="locale" @change="choisir($event.target.value)"
            class="border-0 bg-transparent py-0 pl-1 pr-6 text-sm focus:ring-0 cursor-pointer">
      <option v-for="l in langues" :key="l.code" :value="l.code">{{ l.nom }}</option>
    </select>
  </label>
</template>

<script>
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { LANGUES, choisirLangue } from '@/i18n';
import { enregistrerLangueCompte } from '@/i18n/compte';

export default defineComponent({
  name: 'LangueSelect',
  setup() {
    const { locale } = useI18n({ useScope: 'global' });
    // Choisie connecté : enregistrée aussi sur le compte, pour que les e-mails (et les alertes
    // des contacts sans langue) suivent.
    const choisir = code => { choisirLangue(code); enregistrerLangueCompte(code); };
    return { locale, langues: LANGUES, choisir };
  }
});
</script>
